import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import dateFunctions from '../../functions/dateFunctions';

class Contactos extends Component {
    constructor() {
        super();
        this.state = {
            fechaContacto: null,
            fecha: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha de Contacto",
                    id: "fechaContacto",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaContacto),
                    show: true,
                    width: 150,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Subgrupo",
                    id: "subgrupo__padre__nombre",
                    accessor: d => d.subgrupo__padre__nombre,
                    show: false,
                    private: true,
                },
                {
                    Header: "Subgrupo",
                    id: "subgrupo__nombre",
                    accessor: d => d.subgrupo__padre__nombre + " > " + d.subgrupo__nombre,
                    show: false,
                },
                {
                    Header: "Empresa/Organización",
                    id: "empresa__nombre",
                    accessor: d => d.empresa__nombre,
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "observaciones",
                    accessor: d => d.observaciones,
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "telefono",
                    accessor: "telefono",
                    filterable: false,
                    width: 100,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "email",
                    accessor: "email",
                    filterable: true,
                    width: 200,
                    show: true,
                },
                {
                    Header: "Registrante",
                    id: "fullname",
                    accessor: d => d.fullname,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'gestionprevia_add',
                        component: Create,
                    },
                    {
                        detail: true,
                        permission: 'gestionprevia_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'gestionprevia_edit',
                        component: Edit,
                    },
                    {
                        edit: true,
                        permission: 'gestionprevia_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.contactos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.contactos.export}
                title={"Gestión"}
            />
        );
    }
}

export default Contactos;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Contactos.js